module.exports = __webpack_public_path__ + "img/creature_on.1f203964.svg";